module.exports = __webpack_public_path__ + "static/media/Calibre-Regular.e0823214.woff";